import { getActionCardModule } from '../actionCardModule'
import getNodesVisibilityRules from './nodesVisibilityRules'
const { ActionCardModel } = await getActionCardModule()

export default class WebPlayActionCardService {
  baseService

  constructor(serviceSource) {
    if (!serviceSource) {
      return
    }
    if (serviceSource.getActionCardModel) {
      this.baseService = serviceSource
    } else if (serviceSource instanceof ActionCardModel) {
      serviceSource.nodesVisibilityRules.addRange(getNodesVisibilityRules())
      this.baseService = {
        getActionCardModel: function () {
          return serviceSource
        },
      }
    } else {
      const actionCardModel = new ActionCardModel(serviceSource)
      actionCardModel.nodesVisibilityRules.addRange(getNodesVisibilityRules())
      this.baseService = {
        getActionCardModel: function () {
          return actionCardModel
        },
      }
    }
  }

  getActionCardModel() {
    return this.baseService?.getActionCardModel?.()
  }

  getEmailNode() {
    const emails = this.baseService?.getActionCardModel?.().getSearchService().filterEmails().toSearchService()

    if (!emails) {
      return
    }

    return (
      emails.filterNotEmptyInputNodes().filterVisible().find() ??
      emails.filterVisible().find() ??
      emails.filterNotEmptyInputNodes().find() ??
      emails.find()
    )
  }

  adjustEmail(email) {
    if (!email) {
      return
    }

    const emailNodesSearchService = this.baseService
      ?.getActionCardModel?.()
      .getSearchService()
      .filterEmails()
      .toSearchService()

    if (!emailNodesSearchService) {
      return
    }

    const emailNode = emailNodesSearchService.filterVisible().find() ?? emailNodesSearchService.find()
    emailNode?.setValue(email)
  }

  adjustModelFromQueryString() {
    const modesSearchService = this.baseService?.getActionCardModel?.()?.getSearchService()
    if (!modesSearchService) {
      return
    }
    for (const { questionCode, value } of iterateInitialNodesValuesFromQueryString()) {
      // try/catch is used to suppress expected exceptions (e.g. setValue of FileQuestionNode)
      try {
        modesSearchService.findQuestionByCode(questionCode)?.setStringValue(value)
      } catch (ex) {
        console.error(ex)
      }
    }
  }
}

function* iterateInitialNodesValuesFromQueryString() {
  const nodeValueParameterPrefix = 'f_'
  const searchParams = new URL(location.href).searchParams
  for (const [key, value] of searchParams.entries()) {
    if (key.startsWith(nodeValueParameterPrefix)) {
      yield { questionCode: key.substring(nodeValueParameterPrefix.length), value }
    }
  }
}
